module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_is-object.js
// module id = 48
// module chunks = 0